import { render, staticRenderFns } from "./WalletStatus.vue?vue&type=template&id=0d838240&"
import script from "./WalletStatus.vue?vue&type=script&lang=js&"
export * from "./WalletStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports